import { render, staticRenderFns } from "./CollectionReportInfoCard.vue?vue&type=template&id=ce4d5d7c&scoped=true&"
import script from "./CollectionReportInfoCard.vue?vue&type=script&lang=js&"
export * from "./CollectionReportInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CollectionReportInfoCard.vue?vue&type=style&index=0&id=ce4d5d7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4d5d7c",
  null
  
)

export default component.exports